<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone"
  >
    <span>Drag or Drop Picture</span>
    <span>OR</span>
    <label for="dropzoneFile">Select Picture</label>
    <input type="file" id="dropzoneFile" class="dropzoneFile" accept="image/*" required />
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'DropZone',
  setup () {
    const active = ref(false)
    const toggleActive = () => {
      active.value = !active.value
    }
    return { active, toggleActive }
  }
}
</script>

<style>
.dropzone {
  width: 300px;
  height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  border: 2px dashed #41b883;
  background-color: #fff;
  transition: 0.3s ease all;
}
.dropzone label {
  padding: 8px 12px;
  color: #fff;
  background-color: #41b883;
  transition: 0.3s ease all;
}
.dropzone input {
  display: none;
}
.dropzone .active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #41b883;
}
.dropzone .active-dropzone label {
  background-color: #fff;
  color: #41b883;
}
</style>
